// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"1ad1f69b","453":"f02c49a3"}[chunkId] + ".chunk.js";
};